/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Product_Id_LabelInputs */

const en_admin_payments_product_id_label = /** @type {(inputs: Admin_Payments_Product_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product ID`)
};

/**
* | output |
* | --- |
* | "Product ID" |
*
* @param {Admin_Payments_Product_Id_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_payments_product_id_label = /** @type {((inputs?: Admin_Payments_Product_Id_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Product_Id_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_payments_product_id_label(inputs)
});
export { admin_payments_product_id_label as "admin.payments.product_id_label" }